import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getCategoriasCNH } from '../../../api';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var COLUNAS = [
    {
        field: 'nome',
        headerName: 'Nome',
        width: 650,
    },
    {
        field: 'situacao',
        headerName: 'Situação',
        width: 150,
    },
];
var CategoriasCNH = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.CATEGORIAS_CNH, paginaPermissao: FUNCIONALIDADES.CATEGORIAS_CNH, rota: ROUTES.CATEGORIAS_CNH, columns: COLUNAS, filtrosIniciais: {
            situacao: '',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            return getCategoriasCNH(textoBusca === '' ? null : textoBusca, filtros.situacao === '' || filtros.situacao === '-1' ? null : filtros.situacao, paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizarFiltros({ situacao: novaSituacao });
            } })); } }));
};
export default CategoriasCNH;
